import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	more: {
		id: 'servicedesk-sla-settings.calendars.summary-with-actions.more',
		defaultMessage: 'More actions for {name}',
		description: 'label for more icon',
	},
	editCalendar: {
		id: 'servicedesk-sla-settings.calendars.summary-with-actions.edit-calendar',
		defaultMessage: 'Edit',
		description: 'label for edit Calendar',
	},
	deleteCalendar: {
		id: 'servicedesk-sla-settings.calendars.summary-with-actions.delete-calendar',
		defaultMessage: 'Delete',
		description: 'label for delete Calendar',
	},
	activeCalendar: {
		id: 'servicedesk-sla-settings.calendars.summary-with-actions.active-calendar',
		defaultMessage: 'In use',
		description: 'label for a non deletable Calendar',
	},
	showDetails: {
		id: 'servicedesk-sla-settings.calendars.summary-with-actions.show-details',
		defaultMessage: 'Show details of {name}',
		description: 'label for right chevron icon',
	},
	hideDetails: {
		id: 'servicedesk-sla-settings.calendars.summary-with-actions.hide-details',
		defaultMessage: 'Hide details of {name}',
		description: 'label for down chevron icon',
	},
	copyCalendars: {
		id: 'servicedesk-sla-settings.calendars.summary-with-actions.copy-calendars',
		defaultMessage: 'Copy to this service project',
		description: 'label for copying calendars from other projects',
	},
	cloneCalendars: {
		id: 'servicedesk-sla-settings.calendars.summary-with-actions.clone-calendars',
		defaultMessage: 'Copy',
		description: 'label for copying calendars from the current service desk project',
	},
	createdOn: {
		id: 'servicedesk-sla-settings.calendars.summary-with-actions.created-on',
		defaultMessage: 'Created on {date}',
		description: 'Tooltip on Other project calendars icon that says when the calendar was created',
	},
	updatedOn: {
		id: 'servicedesk-sla-settings.calendars.summary-with-actions.updated-on',
		defaultMessage: 'Updated on {date}',
		description:
			'Tooltip on Other project calendars icon that says when the calendar was last updated',
	},
	from: {
		id: 'servicedesk-sla-settings.calendars.summary-with-actions.from',
		defaultMessage: 'from {serviceDeskName}',
		description: 'Label for displaying the name of the serviceDesk project the calendar belongs to',
	},
});
